var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCourses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.26562 0.183154C8.73125 -0.0594238 9.26875 -0.0594238 9.73438 0.183154L16.5656 3.73394C16.8312 3.87104 17 4.16987 17 4.50034C17 4.83081 16.8312 5.12964 16.5656 5.26675L9.73438 8.81753C9.26875 9.06011 8.73125 9.06011 8.26562 8.81753L1.43438 5.26675C1.16875 5.12612 1 4.82729 1 4.50034C1 4.17339 1.16875 3.87104 1.43438 3.73394L8.26562 0.183154ZM14.9031 7.36909L16.5656 8.23394C16.8312 8.37105 17 8.66987 17 9.00034C17 9.33081 16.8312 9.62964 16.5656 9.76675L9.73438 13.3175C9.26875 13.5601 8.73125 13.5601 8.26562 13.3175L1.43438 9.76675C1.16875 9.62612 1 9.3273 1 9.00034C1 8.67339 1.16875 8.37105 1.43438 8.23394L3.09687 7.36909L7.84688 9.83706C8.57812 10.2167 9.42188 10.2167 10.1531 9.83706L14.9031 7.36909ZM10.1531 14.3371L14.9031 11.8691L16.5656 12.7339C16.8312 12.871 17 13.1699 17 13.5003C17 13.8308 16.8312 14.1296 16.5656 14.2667L9.73438 17.8175C9.26875 18.0601 8.73125 18.0601 8.26562 17.8175L1.43438 14.2667C1.16875 14.1261 1 13.8273 1 13.5003C1 13.1734 1.16875 12.871 1.43438 12.7339L3.09687 11.8691L7.84688 14.3371C8.57812 14.7167 9.42188 14.7167 10.1531 14.3371Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourses);
export default __webpack_public_path__ + "static/media/courses.3c1d4874ab32f225445768e3dedfe9f3.svg";
export { ForwardRef as ReactComponent };